"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useErrorNavigation = require("../../hooks/error/useErrorNavigation");
var _HeaderTop = _interopRequireDefault(require("../shared/HeaderTop"));
var _QuestionHeader = require("../Questionnaire/QuestionHeader");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const HeaderWrapper = _styledComponents.default.div`
  padding: ${prop => prop.padding};
  margin-bottom: ${prop => prop.margin};
`;
const ErrorHeader = () => {
  const {
    onRestart
  } = (0, _useErrorNavigation.useErrorNavigation)();
  const padding = (0, _useLocalTheme.default)('header.errorPadding');
  const margin = (0, _useLocalTheme.default)('header.marginBottom');
  return /*#__PURE__*/_react.default.createElement(HeaderWrapper, {
    padding: padding,
    margin: margin
  }, /*#__PURE__*/_react.default.createElement(_HeaderTop.default, {
    actionComponent: /*#__PURE__*/_react.default.createElement(_QuestionHeader.RestartBtnComponent, {
      placement: "header",
      isRestartVisible: true,
      onRestart: onRestart
    })
  }));
};
var _default = ErrorHeader;
exports.default = _default;